import { render } from "./HomeView.vue?vue&type=template&id=00845c4d&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=00845c4d&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a2-CI\\_work\\63\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00845c4d"]])

export default __exports__